/* THIS IS A GENERATED FILE. PLEASE DO NOT MODIFY!! */
import * as Types from '../../../../types/dashboard-core-gqlTypes.generated.d';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions =  {}
export type GenerateOmniEmbedUrlQueryVariablesGQLType = Types.Exact<{
  organizationId: Types.Scalars['UUID'];
  embedParams: Types.OmniEmbedParamsGQLType;
}>;


export type GenerateOmniEmbedUrlQueryGQLType = (
  { __typename?: 'Query' }
  & { response: (
    { __typename?: 'OmniEmbedUrlResponse' }
    & Pick<Types.OmniEmbedUrlResponseGQLType, 'url' | 'error'>
  ) }
);


export const GenerateOmniEmbedUrlDocumentGQLType = gql`
    query GenerateOmniEmbedUrl($organizationId: UUID!, $embedParams: OmniEmbedParams!) {
  response: generateOmniEmbedUrl(
    organizationId: $organizationId
    embedParams: $embedParams
  ) {
    url
    error
  }
}
    `;

/**
 * __useGenerateOmniEmbedUrlQuery__
 *
 * To run a query within a React component, call `useGenerateOmniEmbedUrlQuery` and pass it any options that fit your needs.
 * When your component renders, `useGenerateOmniEmbedUrlQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGenerateOmniEmbedUrlQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      embedParams: // value for 'embedParams'
 *   },
 * });
 */
export function useGenerateOmniEmbedUrlQuery(baseOptions: Apollo.QueryHookOptions<GenerateOmniEmbedUrlQueryGQLType, GenerateOmniEmbedUrlQueryVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GenerateOmniEmbedUrlQueryGQLType, GenerateOmniEmbedUrlQueryVariablesGQLType>(GenerateOmniEmbedUrlDocumentGQLType, options);
      }
export function useGenerateOmniEmbedUrlLazyQueryGQLType(baseOptions?: Apollo.LazyQueryHookOptions<GenerateOmniEmbedUrlQueryGQLType, GenerateOmniEmbedUrlQueryVariablesGQLType>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GenerateOmniEmbedUrlQueryGQLType, GenerateOmniEmbedUrlQueryVariablesGQLType>(GenerateOmniEmbedUrlDocumentGQLType, options);
        }
export type GenerateOmniEmbedUrlQueryHookResult = ReturnType<typeof useGenerateOmniEmbedUrlQuery>;
export type GenerateOmniEmbedUrlLazyQueryGQLTypeHookResult = ReturnType<typeof useGenerateOmniEmbedUrlLazyQueryGQLType>;
export type GenerateOmniEmbedUrlQueryResultGQLType = Apollo.QueryResult<GenerateOmniEmbedUrlQueryGQLType, GenerateOmniEmbedUrlQueryVariablesGQLType>;